import { BaseFiltroPaginate } from 'core/resources/enums/paginate';
import { PaginateQuery } from 'core/resources/types/shared';
import { useCallback, useState } from 'react'

interface FiltroParticipantes extends PaginateQuery {
  prefixos: string;
}

function useFiltroParticipantes() {
  const [filtro, setFiltro] = useState<FiltroParticipantes>({
    page: 1,
    limit: BaseFiltroPaginate.Limit,
    search: '',
    prefixos: 'A-B',
  });
  
  const onChangeFiltro = useCallback((_filtro: Partial<FiltroParticipantes>) => {
    setFiltro(state => ({...state, ..._filtro}))
  }, []);

  return {
    filtro,
    setFiltro,
    onChangeFiltro,
  }
}

export default useFiltroParticipantes
